module.exports = __webpack_public_path__ + "media/slide.ce77875e.mp3";